// extracted by mini-css-extract-plugin
export default {"listItem":"listItem--VJbCi"};